import React, { Component } from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";

import Auth from "../../Auth";
import WorkspacePage from "../WorkspacePage";
import { link } from "../link.js";
import { api } from "../link.js";
import { authMode, refreshProfile } from "../../security/http";
import { hasPermissionAll, hasPermissions, hasPermissionsStrict } from "../../security/permissions";
import { searchGroups } from "../../security/groupSearch";
import SettingsTabs from "./SettingsTabs";
import { confirm } from "../utils/Confirmation";

import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import Loading from "../loading";
import "./Usergroups.css";
export class Usergroups extends Component {
  constructor() {
    super();
    this.state = {
      users: null,
      reportType: "contr",
      reportResults: [],
      userid: "",
      //userlist: null,
      openModal: false,
      groupinfo: { userid: "", action: "", groupid: "", gname: "" },
      cansend: false,
      loading: false,
      search: "",
      permissionGroup: null,
      metadataGroup: null,
      permissionCatalog: [],
      newGroupName: "",
      newGroupDescription: "",
      error: "",
    };
    //this.handleChange = this.handleChange.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    //this.handleChangeDate = this.handleChangeDate.bind(this);
    //this.getReport = this.getReport.bind(this);
  }

  getGroups = (reptype) => {
    if (authMode() === "jwt") {
      axios.get(`${api()}api/security/groups`)
        .then(async (res) => {
          this.setState({ reportResults: Array.isArray(res.data) ? res.data : [], loading: false });
          try { await refreshProfile(); } catch (_) {}
        })
        .catch((error) => {
          Auth.handleHttpCodes(error, "userGroups");
          this.setState({ loading: false, error: "Groups could not be loaded." });
        });
      axios.get(`${api()}api/security/permissions`)
        .then((res) => this.setState({ permissionCatalog: Array.isArray(res.data) ? res.data : [] }))
        .catch(() => {});
      return;
    }
    var token = localStorage.getItem("token");

    var postData = {};
    var headers = {
      "Content-Type": "application/json",
      Authorization: `${token}`,
    };

    localStorage.setItem("currentView", "income");
    axios
      .post(link() + `&do=get&ra=mgroup&ft=all`, postData, { headers: headers,timeout:90000 })
      .then((res) => {
        console.log("RESPONSE RECEIVED: ", res.data);
        if (Array.isArray(res.data))
          this.setState({
            reportResults: res.data,
            loading: false,
          });
      })
      .catch((err) => {

        console.log("Error: ", err);
        Auth.handleHttpCodes(err,"userGroups");
        this.setState({
          isLoading: false,
          loading: false,
        });
       
      });
  };

  getUser = () => {
    if (authMode() === "jwt") {
      axios.get(`${api()}api/security/group-users`)
        .then((res) => this.setState({ users: Array.isArray(res.data) ? res.data : [], loading: false }))
        .catch((error) => {
          Auth.handleHttpCodes(error, "userGroups");
          this.setState({ loading: false });
        });
      return;
    }
    var token = localStorage.getItem("token");
    var postData = {};
    var headers = {
      "Content-Type": "application/json",
      Authorization: `${token}`,
    };

    localStorage.setItem("currentView", "expense");
    axios
      .post(
        link() + `&do=get&ra=user&ft=all`,

        postData,
        { headers: headers }
      )
      .then((res) => {
        console.log("RESPONSE RECEIVED: ", res);
        if (Array.isArray(res.data))
          this.setState({
            users: res.data,
            loading: false,
          });
      })
      .catch((error) => {

        console.log(error);
                  Auth.handleHttpCodes(error,"Overall");
        this.setState({
          isLoading: false,
        });
        //console.log("AXIOS ERROR: ", err);
      });
  };

  componentDidMount = () => {
    this.setState({
      loading: true,
    });
    this.getGroups("");
    if (hasPermissions("MANAGE_USERGROUPS", "MANAGE_PERMISSIONS")) this.getUser();
  };
  handleChangeSelect = (e) => {
    var groupinfo = this.state.groupinfo;

    groupinfo.userid = e.target.value;
    groupinfo.action = "adduser";
    //groupinfo.groupid = groupelement.mgroupID;
    //groupinfo.gname = groupelement.otherName;
    this.setState({
      //openModal: true,
      //recordtoverify: recordv,
      groupinfo: groupinfo,
    });
  };

  handleRemoveUser = async (e, item) => {
    e.preventDefault();
    if (!(await confirm("Remove this user from the group?"))) return;
    if (authMode() === "jwt") {
      try {
        await axios.post(`${api()}api/security/groups/${encodeURIComponent(item.pid)}/members`,
          { userId: item.userid, add: false });
        this.getGroups("");
      } catch (error) {
        Auth.handleHttpCodes(error, "userGroups");
      }
      return;
    }
    var groupinfo = this.state.groupinfo;

    groupinfo.userid = item.userid;
    groupinfo.action = "removeuser";
    groupinfo.groupid = item.pid;
    //groupinfo.groupid = groupelement.mgroupID;
    //groupinfo.gname = groupelement.otherName;
    this.setState({
      //openModal: true,
      //recordtoverify: recordv,
      groupinfo: groupinfo,
    });

    this.updateChanges();
  };

  handleCreateRound = () => {
    window.location.href = window.location.origin + "/Main/CreateRound";
  };
  handleShowMore = () => {
    window.location.href = window.location.origin + "/Main/LoanCheck";
  };
  handleBack = () => {
    window.location.href = window.location.origin + "/Main/Allloans";
  };

  sendChanges = (e) => {
    e.preventDefault();
    this.updateChanges();
  };

  updateChanges() {
    if (authMode() === "jwt") {
      const info = this.state.groupinfo;
      axios.post(`${api()}api/security/groups/${encodeURIComponent(info.groupid)}/members`,
        { userId: info.userid, add: true })
        .then(() => this.getGroups(""))
        .catch((error) => Auth.handleHttpCodes(error, "userGroups"));
      this.closeModal();
      return;
    }
    //e.preventDefault();
    console.log("Submitting useradd");
    var token = localStorage.getItem("token");
    var postData = this.state.groupinfo;
    var headers = {
      "Content-Type": "application/json",
      Authorization: `${token}`,
    };

    localStorage.setItem("currentView", "paymentapproval");
    axios
      .post(
        link() + `&do=add&ra=mgroup`,

        postData,
        { headers: headers }
      )
      .then((res) => {
        console.log("RESPONSE RECEIVED: ", res.data);

        this.getGroups("");
      })
      .catch((err) => {
        this.setState({
          isitLoading: false,
        });
        console.log("AXIOS ERROR: ", err);
      });

    this.closeModal();
  }

  openModal = (groupelement) => {
    //console.log("1. Target= " + e.target.name + ", value= " + e.target.value);
    this.getUser();
    var groupinfo = this.state.groupinfo;

    groupinfo.userid = "";
    groupinfo.action = "adduser";
    groupinfo.groupid = groupelement.mgroupID;
    groupinfo.gname = groupelement.otherName;
    this.setState({
      openModal: true,
      //recordtoverify: recordv,
      groupinfo: groupinfo,
    });

  };

  openPermissionModal = (group) => this.setState({ permissionGroup: group, error: "" });
  openMetadataModal = (group) => this.setState({ metadataGroup: { ...group }, error: "" });

  savePermissions = async () => {
    const group = this.state.permissionGroup;
    if (!group) return;
    try {
      await axios.put(`${api()}api/security/groups/${encodeURIComponent(group.mgroupID)}/permissions`,
        { permissions: (group.permissions || "") });
      this.setState({ permissionGroup: null });
      this.getGroups("");
    } catch (error) {
      this.setState({ error: "Permissions could not be saved." });
      Auth.handleHttpCodes(error, "userGroups");
    }
  };

  togglePermission = (permission) => {
    this.setState((state) => {
      const group = { ...state.permissionGroup };
      const permissions = new Set((group.permissions || "").split(",").filter(Boolean));
      if (permissions.has(permission)) permissions.delete(permission);
      else permissions.add(permission);
      group.permissions = Array.from(permissions).sort().join(",");
      return { permissionGroup: group };
    });
  };

  createGroup = async (event) => {
    event.preventDefault();
    try {
      await axios.post(`${api()}api/security/groups`, {
        name: this.state.newGroupName,
        description: this.state.newGroupDescription,
      });
      this.setState({ newGroupName: "", newGroupDescription: "" });
      this.getGroups("");
    } catch (error) {
      this.setState({ error: "Group could not be created." });
      Auth.handleHttpCodes(error, "userGroups");
    }
  };

  saveGroupMetadata = async (group) => {
    try {
      await axios.put(`${api()}api/security/groups/${encodeURIComponent(group.mgroupID)}`, {
        name: group.name,
        description: group.description,
      });
      this.getGroups("");
    } catch (error) {
      this.setState({ error: "Group details could not be saved." });
      Auth.handleHttpCodes(error, "userGroups");
    }
  };

  deleteGroup = async (group) => {
    if (!(await confirm(`Delete group ${group.otherName || group.name}?`))) return;
    try {
      await axios.delete(`${api()}api/security/groups/${encodeURIComponent(group.mgroupID)}`);
      this.getGroups("");
    } catch (error) {
      this.setState({ error: "Group could not be deleted." });
      Auth.handleHttpCodes(error, "userGroups");
    }
  };
  closeModal = () => {
    let groupinfo = this.state.groupinfo;

    groupinfo.userid = "";
    groupinfo.action = "adduser";
    groupinfo.groupid = "";
    groupinfo.gname = "";
    this.setState({
      openModal: false,
      groupinfo: groupinfo,
    });
  };

  render() {
    const { reportResults, groupinfo, users, loading } = this.state;
    const filteredGroups = searchGroups(reportResults, this.state.search);

    return (
      <WorkspacePage title="System Settings" className="usergroups-page">
        <SettingsTabs className="groups-tabs" />
        {authMode() === "jwt" && hasPermissions("MANAGE_USERGROUPS") && (
          <Form className="groups-create" onSubmit={this.createGroup}>
            <Form.Group controlId="new-group-name"><Form.Label>Group name</Form.Label>
              <Form.Control value={this.state.newGroupName} onChange={(event) => this.setState({ newGroupName: event.target.value })} required />
            </Form.Group>
            <Form.Group controlId="new-group-description"><Form.Label>Description</Form.Label>
              <Form.Control value={this.state.newGroupDescription} onChange={(event) => this.setState({ newGroupDescription: event.target.value })} />
            </Form.Group>
            <Button variant="success" type="submit"><i className="fas fa-plus" aria-hidden="true" />Create group</Button>
          </Form>
        )}
        {authMode() === "jwt" && (
          <Form.Group controlId="group-search" className="groups-search"><Form.Label>Search groups</Form.Label>
            <Form.Control type="search" value={this.state.search} onChange={(event) => this.setState({ search: event.target.value })} placeholder="Name, group ID, description" />
          </Form.Group>
        )}
        {this.state.error && <Alert variant="danger">{this.state.error}</Alert>}
        {loading ? <Loading /> : (
          <div className="groups-grid">
            {filteredGroups.length === 0 && <p role="status">No groups found.</p>}
            {filteredGroups.map((item) => {
              const groupName = item.otherName || item.name || item.mgroupID;
              const systemGroup = item.mgroupID === "security-system-admins";
              const protectedGroup = systemGroup || item.mgroupID.startsWith("security-local-admins-");
              const mayManageSystem = systemGroup && hasPermissionsStrict("SYSTEM_ADMIN");
              const permissionSet = new Set(String(item.permissions || "").split(",").filter(Boolean));
              const mayManageMembership = systemGroup ? mayManageSystem
                : permissionSet.size > 0 ? hasPermissionAll("MANAGE_USERGROUPS", "MANAGE_PERMISSIONS")
                : hasPermissions("MANAGE_USERGROUPS");
              const members = authMode() === "jwt"
                ? String(item.membersID || "").split(",").filter(Boolean).map((userId) => {
                    const user = (users || []).find((candidate) => candidate.userID === userId);
                    return user ? { userid: userId, names: `${user.firstName || ""} ${user.lastName || ""}`.trim(), pid: item.mgroupID } : null;
                  }).filter(Boolean)
                : item.attachment || [];
              return (
                <article className="group-card" key={item.mgroupID} aria-labelledby={`group-title-${item.mgroupID}`}>
                  <div className="group-card-heading">
                    <h2 id={`group-title-${item.mgroupID}`}>{groupName}</h2>
                    {mayManageMembership && <Button variant="outline-secondary" className="group-icon" type="button" title={`Add user to ${groupName}`} aria-label={`Add user to ${groupName}`} onClick={() => this.openModal(item)}><i className="fas fa-user-plus" aria-hidden="true" /></Button>}
                  </div>
                  {authMode() === "jwt" && <div className="group-metadata">
                    {item.description && <p>{item.description}</p>}
                    <small>{item.mgroupID}</small>
                  </div>}
                  <h3>Members</h3>
                  {members.length === 0 ? <p className="group-empty">No members to display.</p> : <ul className="group-members">
                    {members.map((member) => <li key={member.userid}><span>{member.names || member.userid}</span>
                      {(authMode() !== "jwt" || mayManageMembership) && <Button variant="outline-danger" className="group-icon" type="button" title={`Remove ${member.names || member.userid}`} aria-label={`Remove ${member.names || member.userid} from ${groupName}`} onClick={(event) => this.handleRemoveUser(event, member)}><i className="fas fa-trash-alt" aria-hidden="true" /></Button>}
                    </li>)}
                  </ul>}
                  {authMode() === "jwt" && <div className="group-actions">
                    {hasPermissions("MANAGE_USERGROUPS") && (!systemGroup || mayManageSystem) && <Button variant="outline-secondary" type="button" onClick={() => this.openMetadataModal(item)}><i className="fas fa-pen" aria-hidden="true" />Edit details</Button>}
                    {hasPermissions("MANAGE_PERMISSIONS") && (!systemGroup || mayManageSystem) && <Button variant="outline-secondary" type="button" onClick={() => this.openPermissionModal(item)}><i className="fas fa-key" aria-hidden="true" />Permissions</Button>}
                    {hasPermissions("MANAGE_USERGROUPS") && !protectedGroup && (permissionSet.size === 0 || hasPermissionAll("MANAGE_USERGROUPS", "MANAGE_PERMISSIONS")) && <Button variant="outline-danger" className="group-icon" type="button" title={`Delete ${groupName}`} aria-label={`Delete group ${groupName}`} onClick={() => this.deleteGroup(item)}><i className="fas fa-trash-alt" aria-hidden="true" /></Button>}
                  </div>}
                </article>
              );
            })}
          </div>
        )}
        <Modal show={this.state.openModal} onHide={this.closeModal} className="usergroups-modal" aria-labelledby="add-group-user-title">
          <Modal.Header closeButton><Modal.Title id="add-group-user-title">Add user to {groupinfo.gname}</Modal.Title></Modal.Header>
          <Form onSubmit={this.sendChanges}>
            <Modal.Body><Form.Group controlId="group-user"><Form.Label>User</Form.Label>
              <Form.Control as="select" value={groupinfo.userid} required onChange={this.handleChangeSelect} name="userID">
                <option value="">Select user</option>
                {(users || []).map((user) => <option key={user.userID} value={user.userID}>{user.firstName} {user.lastName}</option>)}
              </Form.Control>
            </Form.Group></Modal.Body>
            <Modal.Footer><Button variant="outline-secondary" type="button" onClick={this.closeModal}>Cancel</Button><Button variant="success" type="submit">Add user</Button></Modal.Footer>
          </Form>
        </Modal>
        <Modal show={Boolean(this.state.permissionGroup)} onHide={() => this.setState({ permissionGroup: null })} className="usergroups-modal" aria-labelledby="group-permissions-title">
          <Modal.Header closeButton><Modal.Title id="group-permissions-title">Group permissions</Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="group-permissions-list">{this.state.permissionGroup && this.state.permissionCatalog.map((permission) => {
              const selected = (this.state.permissionGroup.permissions || "").split(",").includes(permission);
              return <Form.Check key={permission} id={`permission-${permission}`} type="checkbox" label={permission} checked={selected} disabled={permission === "SYSTEM_ADMIN"} onChange={() => this.togglePermission(permission)} />;
            })}</div>
            {this.state.error && <Alert variant="danger">{this.state.error}</Alert>}
          </Modal.Body>
          <Modal.Footer><Button variant="outline-secondary" type="button" onClick={() => this.setState({ permissionGroup: null })}>Cancel</Button><Button variant="success" type="button" onClick={this.savePermissions}>Save permissions</Button></Modal.Footer>
        </Modal>
        <Modal show={Boolean(this.state.metadataGroup)} onHide={() => this.setState({ metadataGroup: null })} className="usergroups-modal" aria-labelledby="group-details-title">
          <Modal.Header closeButton><Modal.Title id="group-details-title">Edit group details</Modal.Title></Modal.Header>
          <Modal.Body>
            {this.state.metadataGroup && <>
              <Form.Group controlId="group-edit-name"><Form.Label>Name</Form.Label><Form.Control value={this.state.metadataGroup.name || ""} onChange={(event) => this.setState({ metadataGroup: { ...this.state.metadataGroup, name: event.target.value, otherName: event.target.value } })} /></Form.Group>
              <Form.Group controlId="group-edit-description"><Form.Label>Description</Form.Label><Form.Control as="textarea" rows={3} value={this.state.metadataGroup.description || ""} onChange={(event) => this.setState({ metadataGroup: { ...this.state.metadataGroup, description: event.target.value } })} /></Form.Group>
            </>}
            {this.state.error && <Alert variant="danger">{this.state.error}</Alert>}
          </Modal.Body>
          <Modal.Footer><Button variant="outline-secondary" type="button" onClick={() => this.setState({ metadataGroup: null })}>Cancel</Button><Button variant="success" type="button" onClick={async () => { await this.saveGroupMetadata(this.state.metadataGroup); this.setState({ metadataGroup: null }); }}>Save details</Button></Modal.Footer>
        </Modal>
      </WorkspacePage>
    );
  }
}

export default Usergroups;
